import __request__ from "routing/request";
export function getStatus(requestOptions) {
  return __request__("GET", "/system/processing/status", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getPersistedStatus(requestOptions) {
  return __request__("GET", "/system/processing/status/persisted", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
